define('services/events/conversation-events',[
    // Libs
    'underscore', 'backbone', 'utils',
    // class
    'src/event-aggregator'

], function(
    // Libs
    _, Backbone, U,
    // class
    EventAggregator
) {

    var ConversationEvents = _.extend({}, EventAggregator.prototype, {
        feedbackSentToSupervisors: function(collection) {
            this.trigger('feedback:sent', collection);
        },

        clickConversation: function(conversationModel) {
            this.trigger('conversation:click', conversationModel);
        },

        markAllAsRead: function() {
            this.trigger('conversation:markAllAsRead');
        },

        showQuestionnaireResponse: function(panel) {
            this.trigger("stack:showQuestionnaireResponse", panel);
        },

        userSelected: function() {
            this.trigger('conversation:userSelected');
        },

        messageAjaxEnd: function() {
            this.trigger('conversation:messageAjaxEnd');
        },

        redirectedToConversation: function () {
            this.trigger('redirectedToConversation');
        },
        markedAsReadOrUnread: function() {
            this.trigger('markedAsReadOrUnread');
        }
    });

    return ConversationEvents;

});

